import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import spinnerTitle from 'components/others/spinnerTitle';

interface ProposalGenerateFormProps {
    sendToClient: boolean;
    setSendToClient: (value: boolean) => void;
    clientEmail: string;
    setClientEmail: (value: string) => void;
    generating: boolean;
    canGenerate: boolean;
    onGenerate: () => void;
}

const ProposalGenerateForm = ({
    sendToClient,
    setSendToClient,
    clientEmail,
    setClientEmail,
    generating,
    canGenerate,
    onGenerate,
}: ProposalGenerateFormProps) => {
    const { t } = useTranslation('Proposal');

    return (
        <>
            <div className="form-check form-switch mb-0">
                <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="proposal-send-to-client"
                    checked={sendToClient}
                    onChange={(e) => setSendToClient(Boolean(e.target.checked))}
                />
                <label className="form-check-label" htmlFor="proposal-send-to-client">
                    {t('edit.generate.sendToClientLabel')}
                </label>
                <div className="small text-muted">{t('edit.generate.sendToClientHint')}</div>
            </div>

            {sendToClient ? (
                <Form.Group className="mt-3 mb-0">
                    <Form.Label>{t('edit.generate.clientEmailLabel')}</Form.Label>
                    <Form.Control
                        type="text"
                        value={clientEmail}
                        onChange={(e) => setClientEmail(e.target.value)}
                        placeholder={t('edit.generate.clientEmailPlaceholder')}
                        autoComplete="email"
                    />
                </Form.Group>
            ) : null}

            <div className="mt-4">
                <Button
                    type="button"
                    variant="primary"
                    disabled={generating || !canGenerate}
                    onClick={onGenerate}
                >
                    {spinnerTitle(
                        <>
                            <i className="bi bi-file-earmark-arrow-down me-2"></i>
                            {t('edit.generate.generateButton')}
                        </>,
                        generating,
                        t('edit.generate.generateButtonLoading'),
                    )}
                </Button>
            </div>
        </>
    );
};

export default ProposalGenerateForm;
